/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Dashboard } from '../../models/dashboard';

export interface PatientGetDashboardList$Params {
  emrpracticeId?: string | null;
  PatientId?: string | null;
}

export function patientGetDashboardList(http: HttpClient, rootUrl: string, params?: PatientGetDashboardList$Params, context?: HttpContext): Observable<StrictHttpResponse<Dashboard>> {
  const rb = new RequestBuilder(rootUrl, patientGetDashboardList.PATH, 'get');
  if (params) {
    rb.query('emrpracticeId', params.emrpracticeId, {});
    rb.query('PatientId', params.PatientId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Dashboard>;
    })
  );
}

patientGetDashboardList.PATH = '/patient/getdashbordlist';
